import { render, staticRenderFns } from "./PageAccess.vue?vue&type=template&id=3cc0566e"
import script from "./PageAccess.vue?vue&type=script&lang=js"
export * from "./PageAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports